export type HttpMethod = "GET" | "POST" | "PUT" | "DELETE";

/** AJAX request options interface. Defines properties required to make an AJAX HTTP request. */
export interface AjaxRequestOptions<TResponseType> {

	/** The URL to call. */
	url: string;

	/** The HTTP method, defaults to HTTP GET. */
	method?: HttpMethod;

	/** Request body data to be sent. */
	data?: any;

	/** Success handler for the AJAX request. */
	success?: (data: TResponseType) => void;

	/** Auth token to send as the authorisation token value. */
	authToken?: string;
}

/** MVC API action call interface. Defines properties required to call an API action. */
export interface ApiAction {

	/** Base URL. Contains scheme, hostname and any virtual directory. */
	baseUrl?: string;

	/** Controller name. */
	controller: string;

	/** Action name. */
	action: string;

	/** Request body data to be sent. */
	data?: any;

	/** The HTTP method, defaults to HTTP GET. */
	method?: HttpMethod;
}

/** API URL interface. Defines properties required to call an API. */
export interface ApiUrl {

	/** Base URL. Contains scheme, hostname and any virtual directory. */
	baseUrl: string;

	/** URL path. */
	path: string;

	/** Request body data to be sent. */
	data: any;

	/** The HTTP method. */
	method?: HttpMethod;
}

/** API response interface, defines the properties that are returned with an API call. */
export interface ApiResponse<TResult> {

	/** Determines if the request was successful and the response is valid. */
	isValid: boolean;

	/** The result of the request. Typcially returned data or information about the action that was performed. */
	result: TResult;
}

/** HTTP methods. */
export class HttpMethods {

	/** HTTP GET */
	public static Get: HttpMethod = "GET";

	/** HTTP POST */
	public static Post: HttpMethod = "POST";

	/** HTTP PUT */
	public static Put: HttpMethod = "PUT";

	/** HTTP DELETE */
	public static Delete: HttpMethod = "DELETE";
}